import { defineMessages } from "react-intl";

import {
	addictionRelatedContraindicationMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/addictionAssessment";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	addictionAssessment: {
		id: "form.addiction_assessment",
		defaultMessage: "Addiktológiai vélemény"
	},
	addictionRelatedContraindication: {
		id: "form.addiction_assessment.addiction_related_contraindication",
		defaultMessage: "Vélemény"
	}
});

const fields: { [key: string]: FieldData } = {
	addictionRelatedContraindication: {
		type: "field",
		path: ["addictionRelatedContraindication"],
		label: messages.addictionRelatedContraindication,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: addictionRelatedContraindicationMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 12, field: fields.addictionRelatedContraindication }
			]
		}
	]
};

export const node: LeafNode = {
	id: "addictionAssessment",
	value: {
		title: messages.addictionAssessment,
		validator,
		fieldset
	}
};
